// link de checkout — usado quando o desafio está com inscrições abertas
export const CHECKOUT_URL = "https://pay.hotmart.com/R101469275F?off=b70lo8b3";

// lista de espera da comunidade (o desafio dessa turma já começou):
// grupo de WhatsApp — mesmo link que fica na página principal (duducrespo.com)
export const WAITLIST_URL = "https://chat.whatsapp.com/Cjz4RHs9acl4fo4xFh2Oph";

// data-alvo do countdown (início do desafio, fuso de Brasília)
export const START_DATE_ISO = "2026-07-27T00:00:00-03:00";
